import request from '@/utils/request'

/**
 * 用户中心（用户列表 / 会员管理）接口
 *
 * 全部复用已有的用户模块接口：
 *   /user/user/page                        用户分页
 *   /user/user/{memberCode}                用户详情
 *   PUT /user/user/                        更新用户（含改密码）
 *   /user/user/vip/subscriptions/{code}    用户的 VIP 订阅记录
 *
 */

/**
 * 用户分页
 * @param {Object} params - memberCode / memberName / memberVip / vipPeriod / paid / page / limit
 *        paid: 留空不过滤，1=注册/付费用户，2=游客
 */
export function getUserPage (params) {
  return request({
    url: '/user/user/page',
    method: 'get',
    params
  })
}

/**
 * 用户详情
 */
export function getUserInfo (memberCode) {
  return request({
    url: `/user/user/${memberCode}`,
    method: 'get'
  })
}

/**
 * 更新用户
 * 传 newPassword 即修改密码（与旧后台 movie-admin-ui 同一个接口）
 */
export function updateUser (data) {
  return request({
    url: '/user/user/',
    method: 'put',
    data
  })
}

/**
 * 单个用户的 VIP 订阅记录
 */
export function getVipSubscriptions (memberCode) {
  return request({
    url: `/user/user/vip/subscriptions/${memberCode}`,
    method: 'get'
  })
}

/**
 * VIP 订阅记录分页（全站）
 * @param {Object} params - page / limit / memberCode / vipLevel / status
 */
export function getVipSubscriptionPage (params) {
  return request({
    url: '/user/user/vip/subscriptions/page',
    method: 'get',
    params
  })
}

// ---------- 字典 ----------

// 用户类型（接口参数 paid）
export const USER_PAID_TYPE = {
  REGISTERED: 1,
  GUEST: 2
}

export const USER_PAID_OPTIONS = [
  { label: '注册 / 付费', value: USER_PAID_TYPE.REGISTERED },
  { label: '游客', value: USER_PAID_TYPE.GUEST }
]

// 用户表 vipPeriod，与套餐规格（tb_commodity.commodity_specification）同一套枚举
export const VIP_PERIOD_MAP = {
  0: '非会员',
  1: '包天',
  2: '包周',
  3: '包月',
  4: '包季',
  5: '包年',
  6: '终身',
  7: '包时'
}

// 终身会员没有到期时间
export const VIP_PERIOD_FOREVER = 6

/**
 * 会员类型下拉选项
 * 用数组而不是直接遍历 VIP_PERIOD_MAP，是因为对象的整数键会按数值升序排列，
 * 包时(7) 会被排到最后，这里按时长顺序手动排列
 */
export const VIP_PERIOD_OPTIONS = [
  { label: '包时', value: 7 },
  { label: '包天', value: 1 },
  { label: '包周', value: 2 },
  { label: '包月', value: 3 },
  { label: '包季', value: 4 },
  { label: '包年', value: 5 },
  { label: '终身', value: 6 }
]

/**
 * 订阅表 vipLevel
 * 与用户表的 vipPeriod 使用同一套对应关系，
 * 开通会员时也按这套赋值，避免两处枚举不一致
 */
export const VIP_LEVEL_MAP = VIP_PERIOD_MAP

// 开通 / 续期会员时可选的等级，与筛选下拉同一套
export const VIP_LEVEL_OPTIONS = VIP_PERIOD_OPTIONS

// 订阅表 sourceType（开通方式）
export const SOURCE_TYPE_MAP = {
  1: '充值购买',
  2: '签到赠送',
  3: '邀请奖励',
  4: '活动奖励',
  5: '系统赠送'
}

// 订阅表 status
export const SUBSCRIPTION_STATUS_MAP = {
  0: '待生效',
  1: '生效中',
  2: '已过期',
  3: '已使用完',
  4: '禁用中'
}

// 会员统计分组：与用户表 vipPeriod 对应
export const VIP_STAT_GROUPS = [
  { label: '包时 / 包天 / 包周', periods: [7, 1, 2] },
  { label: '包月', periods: [3] },
  { label: '包季 / 包年', periods: [4, 5] },
  { label: '终身', periods: [6] }
]

